import apiClient from './client';

export const notificationAPI = {
  getAll: (params) => apiClient.get('/notifications', { params }),
  markAsRead: (id) => apiClient.put(`/notifications/${id}/read`),
  markAllAsRead: () => apiClient.put('/notifications/read-all'),
  delete: (id) => apiClient.delete(`/notifications/${id}`),
  getPreferences: () => apiClient.get('/notifications/preferences'),
  updatePreferences: (data) => apiClient.put('/notifications/preferences', data),
  registerDeviceToken: (data) => apiClient.post('/notifications/device-token', data),
  unregisterDeviceToken: (data) => apiClient.delete('/notifications/device-token', { data }),
};
